export enum ApiGatewayLpStatus {
  Active = 'ACTIVE',
  Backup = 'BACKUP',
}

export interface IApiGatewayLp {
  available: boolean;
  id: string;
  name: string;
  status: ApiGatewayLpStatus;
}
